<script>
import { FallbackImageElementMixin } from "%/dynamic-component-editor/standard-elements/image-element/fallback-image-element-mixin";
import { ShowPageElementMixin } from "%/dynamic-component-editor/standard-pages/show-page/show-page-element-mixin";
import BaseImageElement
  from "%/dynamic-component-editor/standard-elements/image-element/BaseImageElement.vue";

export default {
  name: "ShowCoverImage",
  extends: BaseImageElement,
  elementPanelSettings: {
    displayName: "Cover Image",
    displayIcon: "image",
    elementType: "element",
    elementGroup: "show",
  },
  mixins: [FallbackImageElementMixin, ShowPageElementMixin],
  computed: {
    imageSrc() {
      return this.entity.coverImage;
    },
  },
};
</script>
